import { SignOut, UserCircle } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuth } from '@/hooks/use-auth';
import { useSignOut } from '@/hooks/use-sign-out';

/**
 * A conta logada e a saída dela.
 *
 * **Aparece em toda tela do ramo protegido**, não só na vitrine: sair é uma
 * necessidade da sessão, não da tela. Até aqui o único "Sair" do app morava no
 * `NoAccess`, e quem tinha acesso — justamente o cliente comum — não tinha
 * como deslogar.
 *
 * Mostra quem está logado antes da ação: em computador compartilhado, é isso
 * que diz à pessoa que a sessão aberta não é a dela.
 */
export function AccountMenu() {
  const { user } = useAuth();
  const { signOut, leaving } = useSignOut();

  if (!user) return null;

  // O buyer pode não ter e-mail (entra por telefone) — ver `AuthUser.email`.
  const identifier = user.email || user.phone;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon-sm" aria-label="Minha conta">
          <UserCircle size={20} aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="space-y-0.5">
          <span className="block truncate text-sm font-semibold text-foreground">
            {user.name}
          </span>
          {identifier && (
            <span className="block truncate text-sm font-normal text-muted-foreground">
              {identifier}
            </span>
          )}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          disabled={leaving}
          // `preventDefault` mantém o menu aberto até o reload: fechado, o
          // "Saindo..." não apareceria e o clique pareceria não ter feito nada.
          onSelect={(event) => {
            event.preventDefault();
            signOut();
          }}
        >
          <SignOut size={16} aria-hidden />
          {leaving ? 'Saindo...' : 'Sair da conta'}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
